<template>
    <div class="searchbx" name="search">
        <div id="inner-box">
            <label><h2>Please type your home address:</h2></label>

            <form @submit.stop.prevent="submit" ref="form">
                <label>
                    <div v-if="loading"><b>Loading</b></div>
                    <div class="spinloader" v-if="loading"/>
                    <input v-else v-model="inputtext" v-on:input="filterer" list="adr-inp"
                           placeholder="Enter Your Address" ref="input"/>
                </label>
                <datalist id="adr-inp">
                    <option v-for="(item, index) in filteredlist" v-bind:key="index" v-bind:value="item.address">
                        {{item.city}}
                    </option>
                </datalist>
                <button v-if="!loading">Search</button>
            </form>
            <p id="err-hidden" v-if="haserror"><b><i>Address not found, please select one from the dropdown.</i></b></p>
            <h4 v-if="!loading" id="example-search"><i>Example: 123 Main St, San Francisco</i></h4>
        </div>
    </div>
</template>

<script>
    import {AXIOS} from '../services/main'

    export default {
        props: ['dataset'],
        data() {
            return {
                haserror: false,
                ds: null,
                address: null,
                inputtext: '',
                selected: [],
                errors: [],
                data: [],
                filteredlist: null,
                loading: true,
            }
        },
        mounted() {
            const url = '/PickupCalendar/' + this.dataset + '/search';
            AXIOS.get(url)
                 .then(response => {
                     this.data = response.data;
                     this.ds = this.dataset;
                     this.loading = false;
                 })
                 .catch(e => {
                     this.errors.push(e)
                 })
            ;
        },
        methods: {
            submit: function () {

                let inp = this.$refs.input.value;
                let cust = '';
                let comp = '';
                let addr = '';
                for (let x in this.data) {
                    if (this.data[x].address === inp) {
                        addr = this.data[x].address;
                        cust = this.data[x].customer;
                        comp = this.data[x].company;
                    }
                }
                if (cust !== '' && comp !== '') {
                    this.$router.push({name: 'calendar', params: {customer: cust, company: comp, address: addr}})
                        .then().catch(e => {
                        this.error.push(e)
                    });
                } else {
                    this.haserror = true;
                }

            },
            filterer: function () {
                let inp = this.inputtext;
                let dl = this.data;
                let retList;
                if (inp.length > 5) {
                    retList = dl.filter(z => {
                        return z.address.indexOf(inp.toUpperCase()) !== -1;
                    });
                }
                this.filteredlist = retList;
            },
        }
        ,

    }
    ;

</script>
<style lang="scss" scoped>
    html, body {
        height: 100%;
        width: 100%;
    }

    #err-hidden {
        margin-top: 5px;
        margin-right: 50px;
        padding: 0;
        color: red;
    }

    #example-search {
        margin-top: 5px;
        padding-right: 175px;
    }

    .searchbx {
        border: 1px solid #CCCCCC;
        background-color: #FFFFFF;
        padding: 20px;
        text-align: center;
        align-content: center;
        height: 100vh;
    }

    input {
        width: 350px;
    }

    .spinloader {
        border: 16px solid #f3f3f3; /* Light grey */
        border-top: 16px solid #3498db; /* Blue */
        border-radius: 50%;
        align-content: center;
        text-align: center;
        margin: auto;
        width: 75px;
        height: 75px;
        animation: spin 2s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    datalist {
        width: 300px;
    }

    #inner-box {
        margin-left: auto;
        margin-right: auto;
    }

</style>